export default __webpack_public_path__ + "static/media/markerIcon.abee1463.svg";